import React from 'react';
import styled from 'styled-components';
import { Box } from '../neta';
import Img from 'gatsby-image';

const StyledImg = styled(Img)`
  width: 100%;
  overflow: hidden;
  max-height: 15rem;
  min-height: 15rem;
`;

export default class PreviewImg extends React.Component {
  render() {
    const { large, sizes, alt = '' } = this.props;
    return (
      <Box width={[1, large ? 1 : '10em']}>
        <StyledImg alt={alt} sizes={sizes} />
      </Box>
    );
  }
}
